import * as React from 'react'

import { ReportType } from 'app/constants/reportType'

import ComplexRaportForm from '../forms/complexRaport/ComplexRaportForm'
import ShortRaportForm from '../forms/shortRaport/ShortRaportForm'

import Violations from '../forms/shortRaport/Violations'
import ViolationsGrouped from '../forms/shortRaport/ViolationsGrouped'
import AvailableTime from '../forms/shortRaport/AvailableTime'
import Timesheet from '../forms/shortRaport/Timesheet'
import Delegations from '../forms/shortRaport/Delegations'
import TimesheetHours from '../forms/shortRaport/TimesheetHours'
import LumpSumSettlement from '../forms/shortRaport/LumpSumSettlement'
import TimesheetWorkingHours from '../forms/shortRaport/TimesheetWorkingHours'
import ManagerReport from '../forms/shortRaport/ManagerReport'
import EuRate from '../forms/shortRaport/EuRate'
import StatementOnEmployeesCount from '../forms/shortRaport/StatementOnEmployeesCount'
import DriverActiveness from '../forms/shortRaport/DriverActiveness'
import LeaveApplication from '../forms/shortRaport/LeaveApplication'
import { DatePickerRangeProps } from '@/modules/drivers/types'

type PrintoutParamsRendererProps = {
  selectedReport: ReportType
  companyId: string
  translate: (string) => string
  dateRange?: DatePickerRangeProps
}
type PrintoutParamsRendererState = {}

class PrintoutParamsRenderer extends React.Component<
  PrintoutParamsRendererProps,
  PrintoutParamsRendererState
> {
  constructor(props: PrintoutParamsRendererProps) {
    super(props)
    this.state = {}
  }

  render() {
    return this.renderContent()
  }

  renderContent(): any {
    const selectedReport = this.props.selectedReport

    if (selectedReport == null || selectedReport == ReportType.NONE) {
      return null
    }

    switch (selectedReport) {
      case ReportType.VIOLATIONS:
        return <Violations />

      case ReportType.GROUPED_VIOLATIONS:
        return <ViolationsGrouped />

      case ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL_SIMPLE:
        return <ShortRaportForm cardInsertionPeriods />
      case ReportType.DRIVER_CARD_INSERTION_WITHDRAWAL:
        return <ShortRaportForm cardMarkers />
      case ReportType.DRIVER_AVAILABLE_TIME:
        return <AvailableTime />

      case ReportType.DRIVER_ACTIVITIES:
        return <ComplexRaportForm />

      case ReportType.VEHICLE_ACTIVITIES:
        return <ComplexRaportForm />

      case ReportType.TRIP_SUMMARY:
      case ReportType.BASIC_TRIP_PRINT:
      case ReportType.GROUPED_TRIP_BASICS:
      case ReportType.TRIP_GENERAL_STATEMENT:
      case ReportType.TRIP_DETAILS:
      case ReportType.BUSINESS_TRIP_COMMAND:
      case ReportType.TRIP_INVOICES:
      case ReportType.FOREIGN_ALLOWANCES:
        return (
          <Delegations
            key={selectedReport}
            rememberedFilterReport={selectedReport}
            companyId={this.props.companyId}
          />
        )

      case ReportType.MANAGER_REPORT_2:
      case ReportType.TIMESHEET_DETAILED_WAGE_REPORT:
        return <Delegations key={selectedReport} />

      case ReportType.TRIP_COSTS:
        return (
          <Delegations
            key={selectedReport}
            withOnlyPolish={false}
            rememberedFilterReport={ReportType.TRIP_COSTS}
            companyId={this.props.companyId}
          />
        )

      case ReportType.DRIVER_DAY_DETAILS:
        return <ShortRaportForm vehicleActivity />

      case ReportType.TIMESHEET:
      case ReportType.TIMESHEET_APPLICATION_FOR_OVERHOURS_FOR_DRIVERS:
        return <Timesheet companyId={this.props.companyId} />

      case ReportType.TIMESHEET_REWARD_FOR_DRIVERS:
      case ReportType.TIMESHEET_APPLICATION_FOR_LEAVE_FOR_DRIVERS:
        return <LeaveApplication defaultRange={this.props.dateRange} />

      case ReportType.MANAGER_REPORT_3:
        return <ManagerReport />

      case ReportType.TIMESHEET_SUMMARY:
        return <TimesheetHours />

      case ReportType.TIMESHEET_FOREIGN_AMOUNTS_NEW_VERSION_REPORT:
        return <EuRate companyId={this.props.companyId} includeNorway />

      case ReportType.TIMESHEET_FOREIGN_AMOUNTS_REPORT:
        return <EuRate companyId={this.props.companyId} />

      case ReportType.TIMESHEET_LUMPSUM_SETTLEMENT:
      case ReportType.TIMESHEET_LUMPSUM_SETTLEMENT_SUMMARY:
        return <LumpSumSettlement />

      case ReportType.TIMESHEET_TIME_SUMMARY:
        return <ShortRaportForm vehicleActivity />

      case ReportType.TIMESHEET_WORKING_HOURS:
        return <TimesheetWorkingHours />

      case ReportType.DRIVER_INSTRUCTION:
      case ReportType.OUTGOING_CHECKLIST:
      case ReportType.DRIVER_CARD_APPLICATION:
        return <ShortRaportForm separateFilesOnly />

      case ReportType.DRIVER_ACTIVENESS:
        return <DriverActiveness />
      case ReportType.STATEMENT_ON_EMPLOYEES_COUNT:
        return <StatementOnEmployeesCount />

      default:
        return <ShortRaportForm />
    }
  }
}

export default PrintoutParamsRenderer
